import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * @file 페이지 이동에 따른 스크롤 복원 커스텀 훅
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
